import { render, staticRenderFns } from "./ourService-8-Nav.vue?vue&type=template&id=232b0a8f"
import script from "./ourService-8-Nav.vue?vue&type=script&lang=js"
export * from "./ourService-8-Nav.vue?vue&type=script&lang=js"
import style0 from "./ourService-8-Nav.vue?vue&type=style&index=0&id=232b0a8f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports